// Spreading-compaction API contract.
// Types are sourced directly from the server schema build output
// (v2-server/types/schema/SpreadingCompactionSchema.d.ts) so any drift
// surfaces as a TS error at the client compile step.

import type {
	ICompactionOutline,
	ISpreadingCompactionInput,
	TOffsetType,
} from "@/store/modules/spreading-compaction-types";
import type {
	SpreadingCompactionJobState as ServerSpreadingCompactionJobState,
	SpreadingCompactionListResponse as ServerSpreadingCompactionListResponse,
	SpreadingCompactionRecord as ServerSpreadingCompactionRecord,
	SpreadingCompactionRequest as ServerSpreadingCompactionRequest,
	SpreadingCompactionSurface as ServerSpreadingCompactionSurface,
} from "v2-server/types/schema/SpreadingCompactionSchema";

export type SpreadingCompactionApiSurface = ServerSpreadingCompactionSurface;

export type SpreadingCompactionApiRequest = ServerSpreadingCompactionRequest;
/** One record as returned by GET list / GET one / POST 202; `job` carries the run state. */
export type SpreadingCompactionApiRecord = ServerSpreadingCompactionRecord;
export type SpreadingCompactionApiListResponse =
	ServerSpreadingCompactionListResponse;
/** 転圧外周列 1 層分 (D3D-819)。`points` は Local (m) の flat xyz 閉列 */
export type SpreadingCompactionApiOutline =
	SpreadingCompactionApiRecord["compactionOutline"][number];
export type SpreadingCompactionApiJobState = ServerSpreadingCompactionJobState;

/** wire (split spreading/compaction arrays) → client internal `{surfaces: [...]}`. */
export function mergeApiSurfacesToInput(
	spreading: ReadonlyArray<SpreadingCompactionApiSurface>,
	compaction: ReadonlyArray<SpreadingCompactionApiSurface>,
): ISpreadingCompactionInput {
	const make = (type: TOffsetType) => (s: SpreadingCompactionApiSurface) => ({
		type,
		offset: s.offset,
		geometry: s.data,
	});
	return {
		surfaces: [
			...spreading.map(make("spreading")),
			...compaction.map(make("compaction")),
		],
	};
}

/** レコードの `compactionOutline` → store。旧レコードはサーバが `[]` を返す */
export function toStoreCompactionOutline(
	outline: ReadonlyArray<SpreadingCompactionApiOutline>,
): ICompactionOutline[] {
	return outline.map((o) => ({
		offset: o.offset,
		points: [...o.points],
	}));
}
